import { WITHOUT_PORTFOLIO } from '@constants/Text'

const getPortfolios = (state) => (id_cliente) => {
  if (!id_cliente || !state.dados[id_cliente]) {
    return []
  }
  const lista = state.dados[id_cliente].portfolios || []
  return lista.filter((item) => {
    return item !== WITHOUT_PORTFOLIO
  })
}

export { getPortfolios }
